import '../documents.css';

import { useRecoilValue } from 'recoil';
import { userConfigState } from '../../../recoil/atoms/userConfigState';

import { getTenantColor } from '../../../static/tenantConfigs';

import { getReportScoreDescription, getReportScoreName, getScoreTitleFontSize } from './reportVersions';
import { StringToBooleanMap, StringToNumberMap } from '../../../types/common';
import { StarRating } from '../../controls/input/StarRating';
import { useOpenGlobalModal } from '../../../recoil/hooks/useOpenGlobalModal';
import { translate } from '../../../../common/language/translations';


interface ReportScoresProps {
  scores: StringToNumberMap;
  averageMatchReportScores?: StringToNumberMap;
  handleRatingChange?: (scoreKey: string, value: number) => void;
  requiredScoresToShow?: StringToBooleanMap;
}


export const ReportScores: React.FC<ReportScoresProps> = ({
  scores,
  averageMatchReportScores,
  handleRatingChange,
  requiredScoresToShow,
}) => {

  const userConfig = useRecoilValue(userConfigState);

  const { openTextModal } = useOpenGlobalModal();

  const maxColumns = Object.keys(scores).length <= 4 ? 'one-column' : Object.keys(scores).length <= 10 ? 'two-columns' : 'flex-grid';

  const tenantColor = getTenantColor(userConfig?.club ?? '');


  return (
    <div className={'report-scores-container report-scores-container-' + maxColumns}>

      {Object.entries(scores).map(([scoreKey, score], index) => {

        const isLargeRating = maxColumns !== 'flex-grid' && (maxColumns === 'one-column' || index <= 1);

        const fontSize = isLargeRating
          ? 22
          : 19;

        const paddingBottom = isLargeRating && maxColumns !== 'one-column'
          ? '1vh'
          : undefined;

        const showRequired = requiredScoresToShow && requiredScoresToShow[scoreKey + 'ShowRequired'];

        const scoreName = getReportScoreName(scoreKey, userConfig?.language, userConfig?.club) ?? scoreKey;
        const scoreDescription = getReportScoreDescription(scoreKey, userConfig?.language, userConfig?.club);

        return (
          <div
            key={scoreKey}
            className='report-rating'
            style={{
              paddingBottom: paddingBottom,
            }}
          >
            <div
              className={'report-rating-title' + (scoreDescription ? ' report-rating-title-clickable' : '')}
              style={{ fontSize: getScoreTitleFontSize(scoreName, 14, 12) }}
              onClick={() => scoreDescription ? openTextModal(scoreName, scoreDescription) : undefined}
              title={scoreDescription ? translate('showDescription', userConfig?.language) : undefined}
            >
              {scoreName}
            </div>

            <div className='report-rating-stars'>
              <StarRating
                value={score}
                defaultValue={averageMatchReportScores?.[scoreKey]}
                onChange={handleRatingChange ? (value: number | null) => handleRatingChange(scoreKey, value ?? 0) : undefined}
                size={fontSize}
                color={tenantColor}
                borderColor={handleRatingChange ? '#a7a9ad' : '#9d9fa3'}
              />

              {showRequired && (
                <div className={
                  'document-required-star report-field-required'
                  + (isLargeRating ? ' report-large-rating-required' : ' report-rating-required')
                  + ' fast-fade-in'
                }>
                  *
                </div>
              )}
            </div>

          </div>
        );
      })}
    </div>
  );
};
